import styled from 'styled-components';

import { ReactComponent as CloseIcon } from '@pkg/assets/icons/v2/close.svg';
import { ReactComponent as IconEth } from '@pkg/components/Sections/Profile/icons/eth.svg';

export const FilterChipsWrapper = styled.div`
    margin-bottom: 30px;
    margin-top: 20px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    overflow-x: scroll;

    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    button {
        flex-shrink: 0;
    }

    ::-webkit-scrollbar {
        display: none; /* Safari and Chrome */
    }

    button {
        margin-right: 10px;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding-left: 0;
    }
`;

export const FilterHeading = styled.h4`
    font-family: 'Alliance No.1';
    color: ${({ theme }) => theme.colors.white};
    font-weight: 700;
    margin: 0;
    font-size: 16px;
    opacity: 0.5;
    margin-right: 10px;
    white-space: nowrap;
`;

export const ChipText = styled.p`
    font-family: 'Alliance No.1';
    color: ${({ theme }) => theme.colors.white};
    font-weight: 700;
    margin: 0;
    font-size: 12px;
    text-transform: capitalize;
    white-space: nowrap;
`;

export const ClearAll = styled.p`
    font-family: 'Alliance No.1';
    color: ${({ theme }) => theme.colors.white};
    opacity: 0.5;
    font-weight: 400;
    margin: 0;
    font-size: 14px;
    text-decoration: underline;
    white-space: nowrap;
    padding-right: 20px;
    cursor: pointer;
    &:hover {
        opacity: 0.7;
    }
`;

export const Close = styled(CloseIcon)`
    && {
        width: 10px !important;
        min-width: 10px !important;
    }
`;

export const Diamond = styled(IconEth)`
    && {
        width: 10px;
    }
`;
